import { Item, permissionCheck } from "layouts/Config";
import MobileNavItem from "./MobileNavItem";
import { Box, Stack } from "@mui/material";

const renderItems = ({
  depth = 0,
  items,
  pathname,
}: {
  depth?: number;
  items: Item[];
  pathname?: string | null;
}): JSX.Element[] =>
  items.reduce(
    (acc: JSX.Element[], item) =>
      reduceChildRoutes({
        acc,
        depth,
        item,
        pathname,
      }),
    []
  );

const reduceChildRoutes = ({
  acc,
  depth,
  item,
  pathname,
}: {
  acc: JSX.Element[];
  depth: number;
  item: Item;
  pathname?: string | null;
}): Array<JSX.Element> => {
  const checkPath = !!(item.path && pathname);
  const partialMatch = checkPath ? pathname.includes(item.path!) : false;
  const exactMatch = checkPath ? pathname === item.path : false;
  const underDevelopment = item.underDevelopment ?? false;
  const hasAccess = permissionCheck(item);

  if (underDevelopment) {
    return acc;
  }

  if (!hasAccess) {
    return acc;
  }

  if (item.items) {
    const isChildActive = item.items.some((child: any) => {
      return child.path && pathname && (pathname === child.path || pathname.includes(child.path));
    });

    acc.push(
      <MobileNavItem
        active={isChildActive || partialMatch}
        depth={depth}
        disabled={item.disabled}
        icon={item.icon}
        activeIcon={item.activeIcon}
        key={item.title}
        label={item.label}
        open={isChildActive || partialMatch}
        title={item.title}
        path={item.path}
        featureKey={item.featureKey}
        beta={item.beta}
        badge={item.badge}
      >
        <Stack
          component="ul"
          spacing="3px"
          sx={{
            listStyle: "none",
            m: 0,
            p: 0,
            mt: "3px",
          }}
        >
          {renderItems({
            depth: depth + 1,
            items: item.items,
            pathname,
          })}
        </Stack>
      </MobileNavItem>
    );
  } else {
    acc.push(
      <MobileNavItem
        active={exactMatch || partialMatch}
        depth={depth}
        disabled={item.disabled}
        external={item.external}
        icon={item.icon}
        activeIcon={item.activeIcon}
        key={item.title}
        label={item.label}
        path={item.path}
        title={item.title}
        featureKey={item.featureKey}
        beta={item.beta}
        badge={item.badge}
      />
    );
  }

  return acc;
};

interface CustomProps {
  items?: Item[];
  pathname?: string | null;
  subheader?: string;
}

const MobileNavSection = (props: CustomProps) => {
  return (
    <Stack
      component="ul"
      spacing="3px"
      sx={{
        listStyle: "none",
        m: 0,
        p: 0,
      }}
    >
      {props.subheader && (
        <Box
          component="li"
          sx={{
            textTransform: "uppercase",
            background: "var(--nav-section-title-color)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.66,
            mb: 1,
            ml: 1,
          }}
        >
          {props.subheader}
        </Box>
      )}
      {renderItems({ items: props.items ?? [], pathname: props.pathname })}
    </Stack>
  );
};

export default MobileNavSection;
